import { NgModule } from '@angular/core';
import { SystemxRoutingModule} from '../routes/systemx-routing.module';
import { SharedModule } from './shared.module';
import { SystemxMainComponent } from '../components';
@NgModule({
  declarations: [
    SystemxMainComponent
  ],
  exports: [
    SystemxMainComponent  ],
  imports: [
    SharedModule,
    SystemxRoutingModule
  ],

})

export class SystemxModule { }
